import useTranslator from "../../hooks/useTranslator";
import { haveValue } from "../../helper/common";

const CompanyOnboardingInfoSection = ({
  isCompany,
  formData,
  handleInputChange,
  errors,
}) => {
  const { _t } = useTranslator();

  return (
    <div
      style={{
        width: "100%",
        maxHeight: isCompany ? "1200px" : "0px",
        overflow: "hidden",
        opacity: isCompany ? 1 : 0,
        transition: "max-height 0.5s ease, opacity 0.4s ease",
      }}
    >
      {/* Banner */}
      <div className="company-info-banner-wrap">
        <div className="company-info-banner-content">
          {_t("companyTenantBannerText", "Company tenant registration banner")}
        </div>
      </div>

      {/* Company data */}
      <div className="company-section-divider">
        {_t("companyDetailsSection", "Company section headers")}
      </div>
      <div className="company-fields-grid">
        {/* Legal name — full width */}
        <div className="main-form-group" style={{ width: "100%" }}>
          <div
            className={`form-group ${
              errors.company_legal_name ? "form-group-error" : ""
            }`}
          >
            <label>{_t("legalName", "Company data field labels")}</label>
            <input
              type="text"
              name="company_legal_name"
              placeholder={_t(
                "companyLegalNamePlaceholder",
                "Company data field placeholders"
              )}
              value={formData.company_legal_name || ""}
              onChange={handleInputChange}
            />
          </div>
          {errors.company_legal_name && (
            <p className="error-message">{errors.company_legal_name}</p>
          )}
        </div>

        {/* Tax ID (CIF) */}
        <div className="main-form-group full-width-mobile">
          <div
            className={`form-group ${
              errors.company_cif ? "form-group-error" : ""
            }`}
          >
            <label>{_t("taxIdCif", "Company data field labels")}</label>
            <input
              type="text"
              name="company_cif"
              placeholder={_t(
                "cifPlaceholder",
                "Company data field placeholders"
              )}
              value={formData.company_cif || ""}
              onChange={handleInputChange}
              maxLength={9}
            />
          </div>
          {errors.company_cif && (
            <p className="error-message">{errors.company_cif}</p>
          )}
        </div>

        {/* Company type */}
        <div className="main-form-group full-width-mobile">
          <div
            className={`form-group ${
              errors.company_type ? "form-group-error" : ""
            }`}
          >
            <label>{_t("companyType", "Company data field labels")}</label>
            <select
              name="company_type"
              value={formData.company_type || ""}
              onChange={handleInputChange}
              style={{
                color:
                  (!haveValue(formData?.company_type) ||
                    formData?.company_type === "") &&
                  "#7f7f7f",
              }}
            >
              <option value="" disabled>
                {_t("pleaseSelect")}
              </option>
              <option value="SL">
                {_t("limitedCompanySl", "Company type options")}
              </option>
              <option value="SA">
                {_t("publicLimitedCompanySa", "Company type options")}
              </option>
              <option value="cooperativa">
                {_t("cooperative", "Company type options")}
              </option>
              <option value="other">{_t("other")}</option>
            </select>
            <img src="/images/down-arrow-grey.svg" className="downArrow" />
          </div>
          {errors.company_type && (
            <p className="error-message">{errors.company_type}</p>
          )}
        </div>

        {/* CNAE / Business activity — full width */}
        <div className="main-form-group" style={{ width: "100%" }}>
          <div
            className={`form-group ${
              errors.company_cnae ? "form-group-error" : ""
            }`}
          >
            <label>
              {_t("cnaeBusinessActivity", "Company data field labels")}
            </label>
            <input
              type="text"
              name="company_cnae"
              placeholder={_t(
                "cnaePlaceholder",
                "Company data field placeholders"
              )}
              value={formData.company_cnae || ""}
              onChange={handleInputChange}
            />
          </div>
          {errors.company_cnae && (
            <p className="error-message">{errors.company_cnae}</p>
          )}
        </div>
      </div>

      {/* Legal representative */}
      <div className="company-section-divider" style={{ marginTop: "0.833vw" }}>
        {_t("legalRepresentativeSection", "Company section headers")}
      </div>
      <div className="company-fields-grid">
        {/* Position */}
        <div className="main-form-group full-width-mobile">
          <div
            className={`form-group ${
              errors.company_representative_position ? "form-group-error" : ""
            }`}
          >
            <label>{_t("position", "Company data field labels")}</label>
            <select
              name="company_representative_position"
              value={formData.company_representative_position || ""}
              onChange={handleInputChange}
              style={{
                color:
                  (!haveValue(formData?.company_representative_position) ||
                    formData?.company_representative_position === "") &&
                  "#7f7f7f",
              }}
            >
              <option value="" disabled>
                {_t("pleaseSelect")}
              </option>
              <option value="sole_administrator">
                {_t(
                  "soleAdministrator",
                  "Legal representative position options"
                )}
              </option>
              <option value="authorized_signatory">
                {_t(
                  "authorizedSignatory",
                  "Legal representative position options"
                )}
              </option>
              <option value="ceo">
                {_t("ceo", "Legal representative position options")}
              </option>
            </select>
            <img src="/images/down-arrow-grey.svg" className="downArrow" />
          </div>
          {errors.company_representative_position && (
            <p className="error-message">
              {errors.company_representative_position}
            </p>
          )}
        </div>

        {/* Representative's ID — same field as identity_number */}
        <div className="main-form-group full-width-mobile">
          <div
            className={`form-group ${
              errors.identity_number ? "form-group-error" : ""
            }`}
          >
            <label>{_t("representativeId", "Company data field labels")}</label>
            <input
              type="text"
              name="identity_number"
              placeholder={_t(
                "enterYourRepresentativesId",
                "Text used in onboarding process"
              )}
              value={formData.identity_number || ""}
              onChange={handleInputChange}
              maxLength={9}
              onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab",
                ];
                if (
                  !e.key.match(/^[a-zA-Z0-9]$/) &&
                  !allowedKeys.includes(e.key)
                ) {
                  e.preventDefault();
                }
              }}
            />
          </div>
          {errors.identity_number && (
            <p className="error-message">{errors.identity_number}</p>
          )}
          <p className="company-field-hint">
            {_t("sameDocumentEnteredAbove", "Company data field hints")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompanyOnboardingInfoSection;
